import React, { useState } from "react";
import StrapiService from "../../articles/StrapiService";
import ErrorNotificationComponent from "../../../components/generic/error/ErrorNotificationComponent";
import PrimaryButton from "../../../components/generic/buttons/PrimaryButton";
import CustomModal from "../../../components/generic/custommodal/CustomModal";
import SecondaryButton from "../../../components/generic/buttons/SecondaryButton";
import { Input, notification, Spin } from "antd";
import { publishEvent } from "../../../components/generic/EventPublisher";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";

const { TextArea } = Input;

const TemplateCreator = ({
  organizationIdentifier,
  title,
  templateRequired,
  type,
}) => {
  const user = useReadMemory(MemoryType.USER)
  const strapiService = new StrapiService();
  const [modalOpen, setModalOpen] = useState(false);
  const [template, setTemplate] = useState(null);
  const [templateId, setTemplateId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleTemplateChange = (e) => {
    const { name, value } = e.target;
    setTemplate((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    setButtonLoading(true);
    try {
      const result = await strapiService.updateTemplate(templateId, template);
      setTemplate(result.data.attributes);
      setTemplateId(result.data.id);
      publishEvent("niramaya.organization.template.updated", user, result.data.attributes, template)
      notification.success({
        message: `Template updated successfully!`,
        placement: "bottomRight",
      });
    } catch (error) {
      ErrorNotificationComponent(error);
    } finally {
      setButtonLoading(false);
      setModalOpen(false);
    }
  };

  const handleGetTemplate = async () => {
    setModalOpen(true);
    setLoading(true);
    try {
      const result = await strapiService.getTemplate(
        type,
        organizationIdentifier
      );
      setTemplate(result.data[0].attributes);
      setTemplateId(result.data[0].id);
    } catch (error) {
      ErrorNotificationComponent(error);
    } finally {
      setLoading(false);
    }
  };

  const birthdayModalButtons = (
    <>
      <SecondaryButton
        buttonText="Cancel"
        handleOnClick={() => setModalOpen(false)}
      />
      <PrimaryButton
        buttonText="Update"
        loading={buttonLoading}
        handleOnClick={handleUpdate}
      />
    </>
  );

  return (
    <>
      <PrimaryButton buttonText={title} handleOnClick={handleGetTemplate} />
      {modalOpen && (
        <CustomModal
          title={title}
          isModalOpen={modalOpen}
          closeModal={setModalOpen}
          cssClassName="birthday-wish-modal"
          footer={[birthdayModalButtons]}
        >
          {loading ? (
            <Spin
              size="medium"
              className="d-flex justify-content-center m-auto"
            />
          ) : (
            <>
              {templateRequired?.map((item) => (
                <>
                  <div className="mb-1 font-weight-bold">
                    {item?.label}
                  </div>
                  <TextArea
                    defaultValue={template?.[item?.key]}
                    name={item?.key}
                    onChange={handleTemplateChange}
                    className="mb-2"
                  />
                </>
              ))}
            </>
          )}
        </CustomModal>
      )}
    </>
  );
};

export default TemplateCreator;
